import { request } from '@umijs/max';
import * as custom from './custom-services';

export async function userLoginService(data: any) {
  return request(`/login`, {
    method: 'POST',
    data,
  });
}

export async function otpLoginService(data: any) {
  return request(`/smslogin`, {
    method: 'POST',
    data,
  });
}

export async function adminLoginService(data: any) {
  return request(`/bcareLogin`, {
    method: 'POST',
    data,
  });
}

export async function loginMessageService(params: any) {
  return request(`/bcare/user/login/message`, {
    params,
  });
}

export async function loginMessageValidService(params: any) {
  return request(`/bcare/user/login/message/validate`, {
    method: 'POST',
    params,
  });
}

// 强制修改密码
export async function modLoginUserPwdService(data: any) {
  return request(`/bcare/user/login/properties`, {
    method: 'POST',
    data,
  });
}

// 忘记密码后的修改密码
export async function forgetChangePwdService(data: any) {
  return request(`/bcare/user/login/pwd`, {
    method: 'POST',
    data,
  });
}

export async function getLoggedService() {
  return request(`/bcare/logged`);
}

export async function getAdminLoggedService() {
  return request(`/logged`);
}

export async function getUMLoggedService() {
  return request(`/bcare/um/logged`);
}

export async function getRolesByUserId(userId: number) {
  return request(`/bcare/${userId}/roles`);
}

export async function getMenusService(portalId: number) {
  return request(`/bcare/users/portals/${portalId}/dirmenus`);
}

export async function logoutService() {
  return request(`/logout`);
}

// 查询user交换机接口
export async function getExchangeByUser(params?: any) {
  return request(`/bcare/exchange/list`, {
    method: 'POST',
    data: { ...params, state: 'A' },
  }).then((res) => res.list || []);
}

// 查询配置项接口(服务类型)
export async function getServiceByUser(params: any, filterServices: string) {
  return request(`/bcare/sysparam`, {
    params,
  }).then((res) =>
    // 返回示例 "905:FTTH,26:PSTN,10:ADSL,906:IP Star"
    {
      const services = (res.split(',') || []).map((el: string) => ({
        value: el.split(':')[0],
        label: el.split(':')[1],
      }));
      if (filterServices) {
        return services.filter((el: { value: string }) =>
          filterServices.includes(el.value),
        );
      }
      return services;
    },
  );
}

// 获取登录页图片
export async function getLoginImageService(params: any) {
  return request(`/bcare/theme/imgcfg/${params}`, {});
}

export async function downLoadLoginImageService(data: any) {
  return request(`/bcare/imagecfg/download/${data}`, {
    responseType: 'blob',
    method: 'POST'
  });
}

export default { ...custom };
